module.exports = __webpack_public_path__ + "img/back-of-credit-card.c4c50468.png";